var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0196 3.41016C8.7096 3.41016 6.0196 6.10016 6.0196 9.41016V12.3002C6.0196 12.9102 5.7596 13.8402 5.4496 14.3602L4.2996 16.2702C3.5896 17.4502 4.0796 18.7602 5.3796 19.2002C9.6896 20.6402 14.3396 20.6402 18.6496 19.2002C19.8596 18.8002 20.3896 17.3702 19.7296 16.2702L18.5796 14.3602C18.2796 13.8402 18.0196 12.9102 18.0196 12.3002V9.41016C18.0196 6.11016 15.3196 3.41016 12.0196 3.41016Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8699 3.70043C13.5599 3.61043 13.2399 3.54043 12.9099 3.50043C11.9499 3.38043 11.0299 3.45043 10.1699 3.70043C10.4599 2.96043 11.1799 2.44043 12.0199 2.44043C12.8599 2.44043 13.5799 2.96043 13.8699 3.70043Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0195 19.5596C15.0195 21.2096 13.6695 22.5596 12.0195 22.5596C11.1995 22.5596 10.4395 22.2196 9.89953 21.6796C9.35953 21.1396 9.01953 20.3796 9.01953 19.5596",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.7632e2a2700ccd7ef3d5e6173e1642d5.svg";
export { ForwardRef as ReactComponent };